/*
 *
 * TermsAndConditionsDisputlessPopup
 *
 * @version 1.0.0
 * @author Chiara Amato
 * @since 24-Jun-2025
 */

import TermsAndConditionsDisputlessPopup from './TermsAndConditionsDisputlessPopupContainer'

export default TermsAndConditionsDisputlessPopup
